
import { createClient } from '@supabase/supabase-js';

// WARNUNG FÜR PRODUKTION:
// Diese Schlüssel sind aktuell hardcodiert für die einfache Entwicklung in dieser Umgebung.
// Vor einem öffentlichen Deployment sollten diese durch Environment Variables ersetzt werden:
// const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
// const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

const getCleanUrl = (url: string) => {
  let cleaned = url.trim().replace(/\/+$/, '');
  if (cleaned.endsWith('/rest/v1')) {
    cleaned = cleaned.replace(/\/rest\/v1$/, '');
  }
  return cleaned;
};

const rawUrl = (import.meta.env.VITE_SUPABASE_URL as string) || 'https://nbmdvpzwjslymnjbqsyf.supabase.co';
const supabaseUrl = getCleanUrl(rawUrl);
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string) || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5ibWR2cHp3anNseW1uamJxc3lmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI0Nzc0ODIsImV4cCI6MjA3ODA1MzQ4Mn0.740W-rV7jzXNPi7bIJbaGU8bhoKbes0pQ47iB3V2BbE';


// Custom lock implementation to avoid Navigator LockManager issues (common in iframes)
// We provide a function that handles both (name, callback) and (name, options, callback) signatures.
const customLock = (_name: string, ...args: unknown[]) => {
  // The callback is usually the last argument
  const callback = args[args.length - 1];
  if (typeof callback === 'function') {
    return callback();
  }
  return Promise.resolve();
};
(customLock as { acquire?: unknown }).acquire = customLock;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    lock: customLock
  }
});
